module.exports = __webpack_public_path__ + "img/products-1.c7901a6a.svg";